export default __webpack_public_path__ + "static/media/step_C.31103242.png";